const openButton = document.querySelector('.free-gift-banner__cta')
const closeButton = document.querySelector('.free-gift-popup__close')
const closeButton2nd = document.querySelector(
  '.free-gift-popup__button.free-gift-popup__button--secondary',
)
const cartTrigger = document.querySelector(
  '.free-gift-popup__button.free-gift-popup__button--primary',
)
const productFormButton = document.querySelector(
  '.product-form__buttons .product-form__submit',
)
const questionIcon = document.querySelector('.free-gift-banner__popup-trigger')

openButton &&
  openButton.addEventListener('click', () => {
    document.body.classList.add('show-gift-popup')
  })

document.body.addEventListener('click', (e) => {
  if (e.target.classList.contains('free-gift-popup')) {
    document.body.classList.remove('show-gift-popup')
  }
})

closeButton.addEventListener('click', () => {
  document.body.classList.remove('show-gift-popup')
})

closeButton2nd.addEventListener('click', () => {
  document.body.classList.remove('show-gift-popup')
})

cartTrigger.addEventListener('click', () => {
  document.body.classList.remove('show-gift-popup')

  setTimeout(() => {
    productFormButton.click()
  }, 500)
})

questionIcon &&
  questionIcon.addEventListener('click', () => {
    document.body.classList.add('show-gift-popup')
  })

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('.free-gift-popup')
  if (popup) {
    document.body.appendChild(popup)
    popup.style.position = 'fixed'
    popup.style.zIndex = '999999'
  }
})
